import { ajaxCall } from "./ajax-call";
import { initEmblaCarousels } from './embla-slider';

const relatedBooksSelector = '.js-related-books';

const setupRelatedBooks = () => {
  const relatedBooks = document.querySelector(relatedBooksSelector);
  if (!relatedBooks) return;

  const parameters = relatedBooks.dataset.parameters;

  let hasLoaded = false;
  const scrollTrigger = relatedBooks.offsetTop - window.innerHeight;

  const onScroll = async () => {
    if (hasLoaded) return;

    if (document.documentElement.scrollTop > scrollTrigger) {
      hasLoaded = true;
      relatedBooks.style.visibility = 'visible';

      try {
        await ajaxCall('', relatedBooks, 'upt_related_books', parameters);
        const newCarousel = relatedBooks.querySelector('.related-books__container');
        initEmblaCarousels(newCarousel);
      } catch (error) {
        console.error('Failed to load related books via AJAX:', error);
        relatedBooks.style.display = 'none';
      }
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
};

document.addEventListener("DOMContentLoaded", () => {
    setupRelatedBooks();
}); 